if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.googleOptimizeExperiment()

      this.isCard = this.closest('.product-card-wrapper');
      if (this.isCard) {
        this.handle = this.dataset.handle;
        this.cardContent = this.closest('.card__content');
        this.choicesJs = this.querySelector('[data-choices]');
        if (this.choicesJs) {
          this.loadChoicesJs();
        }
      }
      this.form.addEventListener('change', (ev) => {
        this.onVariantChange()
      })
    }

    googleOptimizeExperiment() {
      const optimizeExperimentId = 'jr_VtfkPTqSvr-C6xBdpnw';
      let optimizeVariant = 0
      if (typeof google_optimize === 'undefined') return
      
      optimizeVariant = google_optimize && google_optimize.get(optimizeExperimentId);
      if (!optimizeVariant || optimizeVariant == 0) return
        
      this.form.insertAdjacentHTML('afterbegin', `<input type="hidden" name="properties[_MBPROMO]" value="${optimizeVariant}" />`)      
      const productInfoContainer = this.closest('.product__info-container')
      if (!productInfoContainer) return
      const productSubtitle = productInfoContainer.querySelector('.discount--test[data-subtitle]')
      if (!productSubtitle) return
      const productSubtitleStr = productSubtitle.dataset.subtitle
      const productSubtitleArr = productSubtitleStr.split('||')
      if (!productSubtitleArr[parseInt(optimizeVariant) - 1]) return
      productSubtitle.innerHTML = productSubtitleArr[parseInt(optimizeVariant) - 1]
      productSubtitle.classList.add('abtest-promo')
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    async onVariantChange() {
      let source
      if (this.isCard) {
        source = this;
      } else {
        source = this.closest('.product__info-container')
      }
      this.isSellingPlan = !!source.querySelector('input[name="purchase_option"][value="selling_plan"]:checked');
      console.debug('isSellingPlan', this.isSellingPlan);
      const selectedSellingPlanEl = source.querySelector('input[name="selling_plan"]:checked');
      if (this.isSellingPlan) {
        if (!selectedSellingPlanEl) {
          const sellingPlansInput = Array.from(source.querySelectorAll('input[name="selling_plan"]'));
          sellingPlansInput[0].checked = true;
        }
      } else {
        if (selectedSellingPlanEl) {
          selectedSellingPlanEl.checked = false;
        }
      }

      if (this.isCard) {
        await this.getProductData();
        this.buildOptions();
        this.updatePrice();
      }
    }

    buildOptions() {
      if (!this.choicesJs) return
      let priceData
      const options = []      
      const selectedVariantId = parseInt(this.querySelector('[name="id"]').value)
      
      this.product.variants.forEach((variant) => {
        if (this.isSellingPlan) {
          const sellingPlan = parseInt(this.querySelector('[name="selling_plan"]').value)
          priceData = variant.selling_plan_allocations.find((selling_plan) => selling_plan.selling_plan_id === sellingPlan)
        } else {
          priceData = variant
        }

        let label = `${variant.title} - ${window.formatMoney(priceData.price)}`
        if (parseFloat(priceData.compare_at_price) > parseFloat(priceData.price)) {
          label += ` <del>${window.formatMoney(priceData.compare_at_price)}</del>`
        }

        options.push({
          value: variant.id,
          label: label,
          selected: selectedVariantId === variant.id,
          disabled: variant.available ? false : true
        })
        
      });

      this.choicesJsInstance.setChoices(
        options,
        'value',
        'label',
        true
      );

      this.choicesJs.closest('.product-form__input').classList.remove('hidden')      
    }

    updatePrice() {
      const variant = this.getSelectedVariant();
      let priceData
      if (this.isSellingPlan) {
        const sellingPlan = parseInt(this.querySelector('[name="selling_plan"]').value)
        priceData = variant.selling_plan_allocations.find((selling_plan) => selling_plan.selling_plan_id === sellingPlan)
      } else {
        priceData = variant
      }
      const price = priceData.price
      const compareAtPrice = priceData.compare_at_price ? priceData.compare_at_price : priceData.price
      const discountAmount = price - compareAtPrice
      const discountPercent = Math.abs(Math.round((discountAmount * 100) / compareAtPrice))

      if (this.isCard) {
        Array.from(this.cardContent.querySelectorAll('.price-item--regular')).forEach((el) => {
          el.innerHTML = window.formatMoney(compareAtPrice)
        });
        this.cardContent.querySelector('.price-item--sale').innerHTML = window.formatMoney(price)
        this.cardContent.querySelector('.price__sale__discount-percent').innerHTML = `${discountPercent}% Off`
  
        if (compareAtPrice > price) {
          this.cardContent.querySelector('.price').classList.add('price--on-sale')
        } else {
          this.cardContent.querySelector('.price').classList.remove('price--on-sale')
        }
      }
    }

    async getProductData() {
      if (!this.product && !this.productLoadTriggered) {
        this.productLoadTriggered = true;
        Array.from(this.cardContent.querySelectorAll('.price, variant-dropdown')).forEach((el) => {
          el.classList.add('skeleton-loading')
        });
        const productReq = await fetch(`/products/${this.handle}.js`);
        this.product = await productReq.json();
        Array.from(this.cardContent.querySelectorAll('.price, variant-dropdown')).forEach((el) => {
          el.classList.remove('skeleton-loading')
        });
      }
      return this.product
    }

    getSelectedVariant() {      
      const variantId = parseInt(this.querySelector('[name="id"]').value)
      return this.product.variants.find((variant) => variant.id === variantId)      
    }

    loadChoicesJs() {
      if (!window.isChoicesJsLoading) {
        window.isChoicesJsLoading = true
        const choicesJsPath = JSON.parse(this.choicesJs.dataset.choices)
        FH.loadStyle(choicesJsPath.css);
        FH.loadScript({
          src: choicesJsPath.js,
          asyncOrDefer: 'async',
          callback: () => {
              this.choicesJsLoaded()
              this.setChoicesJs()
          }
        });
      } else if (window.isChoicesJsLoading === 'loaded') {
        this.setChoicesJs()
      } else {
        window.addEventListener('choicesJsLoaded', () => {
          this.setChoicesJs()
        })
      }
    }

    choicesJsLoaded() {
      window.dispatchEvent(new Event("choicesJsLoaded"))
      window.isChoicesJsLoading = 'loaded'
    }

    setChoicesJs() {
      this.choicesJsInstance = new Choices(this.choicesJs, {
        searchEnabled: false,
        itemSelectText: '',
        placeholder: false,
        callbackOnCreateTemplates: function(template) {
          return {
            item: ({ classNames }, data) => {
              let label = data.label
              if (data.customProperties?.compare_at_price) {
                label += ` <del>${data.customProperties.compare_at_price}</del>`
              }
              return template(`
                <div class="${classNames.item} ${
                data.highlighted
                  ? classNames.highlightedState
                  : classNames.itemSelectable
              } ${
                data.placeholder ? classNames.placeholder : ''
              }" data-item data-id="${data.id}" data-value="${data.value}" ${
                data.active ? 'aria-selected="true"' : ''
              } ${data.disabled ? 'aria-disabled="true"' : ''}>
                  ${label}
                </div>
              `);
            },
            choice: ({ classNames }, data) => {
              let label = data.label
              if (data.customProperties?.compare_at_price) {
                label += ` <del>${data.customProperties.compare_at_price}</del>`
              }
              return template(`
                <div class="${classNames.item} ${classNames.itemChoice} ${
                data.disabled ? classNames.itemDisabled : classNames.itemSelectable
              }" data-select-text="${this.config.itemSelectText}" data-choice ${
                data.disabled
                  ? 'data-choice-disabled aria-disabled="true"'
                  : 'data-choice-selectable'
              } data-id="${data.id}" data-value="${data.value}" ${
                data.groupId > 0 ? 'role="treeitem"' : 'role="option"'
              }>
                  ${label}
                </div>
              `);
            },
          };
        }
      });
      this.choicesJs.closest('.product-form__input.hidden').classList.remove('hidden')
    }
  });
}

if (!customElements.get('selling-plan-picker')) {
  customElements.define('selling-plan-picker', class SellingPlanPicker extends HTMLElement {
    constructor() {
      super();

      this.isCard = this.closest('.product-card-wrapper');
      if (this.isCard) {
        return;
      }

      this.productWrapper = this.closest('.product__info-container');
      this.productForm = this.productWrapper.querySelector('product-form');
      this.form = this.productForm.querySelector('form');
      this.variantRadios = this.productWrapper.querySelector('variant-radios');

      Array.from(this.querySelectorAll('input')).forEach((input) => {
        input.addEventListener('change', (ev) => {
          this.triggerChanges()
        })
      })
    }

    triggerChanges() {
      this.form.dispatchEvent(new Event('change'));
      if (this.variantRadios) {
        this.variantRadios.dispatchEvent(new Event("change"));
      } else {
        this.updateURL();
        this.renderProductInfo();
      }
    }

    updateURL() {
      const variantId = this.productForm.querySelector('input[name="id"]').value;
      const currentSellingPlanId = this.getCurrentSellingPlanId();
      let params = '';
      params += `variant=${variantId}`;
      if (currentSellingPlanId) {
        params += `&selling_plan=${currentSellingPlanId}`;
      }
      window.history.replaceState({ }, '', `${this.dataset.url}?${params}`);
    }
  
    renderProductInfo() {
      const variantId = this.productForm.querySelector('input[name="id"]').value;
      const currentSellingPlanId = this.getCurrentSellingPlanId();
        
      let params = '';
      params += `variant=${variantId}`;
      if (currentSellingPlanId) {
        params += `&selling_plan=${currentSellingPlanId}`;
      }
      params += `&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`;
  
      fetch(`${this.dataset.url}?${params}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(`price-${this.dataset.section}`);
          const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          console.debug({source}, {destination})
          if (source && destination) destination.innerHTML = source.innerHTML;
  
          const price = document.getElementById(`price-${this.dataset.section}`);
  
          if (price) price.classList.remove('visibility-hidden');
        });
    }

    getCurrentSellingPlanId() {
      return this.querySelector('input[name="selling_plan"]:checked')?.value
    }
  })
}